import { render, staticRenderFns } from "./sopStepRisk.vue?vue&type=template&id=173d3a72"
import script from "./sopStepRisk.vue?vue&type=script&lang=js"
export * from "./sopStepRisk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173d3a72')) {
      api.createRecord('173d3a72', component.options)
    } else {
      api.reload('173d3a72', component.options)
    }
    module.hot.accept("./sopStepRisk.vue?vue&type=template&id=173d3a72", function () {
      api.rerender('173d3a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/pim/sopStepRisk.vue"
export default component.exports